import './productlist.scss'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import ProductList from './ProductList'
import { ROUTES } from '../../navigation/route-constants'
import { productChanged } from '../../../actions/order-actions'
import { CATEGORIES } from '../product-constants'

const mapStateToProps = (state, ownProps) => {
    const products = state.webshop.products;
    const filter = ownProps.match.params.filter == ROUTES.GIFTBOXES ? 1 : null;
    const filteredProducts = filter ? _.filter(products, (product) => { return product.category === filter || product.category === CATEGORIES.COMBOBOX }) : products;
    return {
        products: filteredProducts,
        organizerId: state.webshop.organizer.id,
        salesChannel: state.webshop.salesChannel
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators({ productChanged }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductList)